<template>
    <div>
        <q-table
            :data="materials"
            :columns="columns_materials"
            :pagination.sync="server_pagination"
            selection="multiple"
            :selected.sync="materials_selected"
            @request="requestMaterials"
            :loading="loading"
            row-key="material_id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            class="q-mt-md"
            binary-state-sort
            >

            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="negative" icon="far fa-ban" :label="$t('remove')" @click="removeMaterials" class="q-mr-sm" v-if="materials_selected.length > 0" :disable="disableMaterials" />
                <q-btn color="secondary" icon="far fa-plus" :label="$t('add_inputs')" @click="showAddMaterials" :disable="disableMaterials" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th auto-width>
                    <q-checkbox v-model="props.selected" indeterminate-value="some" :disable="disableMaterials" />
                </q-th>

                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props">
                <q-td auto-width>
                    <q-checkbox color="primary" v-model="props.selected" :disable="disableMaterials" />
                </q-td>

                <q-td key="material_id" :props="props">
                    {{ props.row.material_id }}
                </q-td>

                <q-td key="material" :props="props">
                    {{ props.row.material }}
                </q-td>

                <q-td key="qty_material" :props="props">
                    <q-input type="number" v-model="props.row.qty_material"
                        @blur="checkMaterials()"
                        :error="$v.materials.$each[props.row.__index].qty_material.$error"
                        @input="$v.materials.$each[props.row.__index].qty_material.$touch" :disable="disableMaterials"
                    />
                </q-td>

                <q-td key="unit_material_cost" :props="props">
                    $ {{ props.row.unit_material_cost }}
                </q-td>

                <q-td key="total_material_cost" :props="props">
                    $ {{ (props.row.qty_material * props.row.unit_material_cost).toFixed(2) }}
                </q-td>

                <q-td auto-width key="actions" :props="props">
                    <q-btn round flat icon="fal fa-trash" color="negative" @click="removeMaterial(props)" :disable="disableMaterials" />
                </q-td>
            </q-tr>
        </q-table>

        <q-modal v-model="show_materials" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_materials = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('inputs') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-table
                        :data="materials_list"
                        :columns="columns_materials"
                        :pagination.sync="materials_pagination"
                        :filter="filter_materials"
                        @request="requestNewMaterials"
                        :loading="loading"
                        selection="multiple"
                        :selected.sync="materials_selected"
                        row-key="material_id"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[5,10,50,100]"
                        binary-state-sort
                        >

                        <template slot="top" slot-scope="props">
                            <q-search v-model="filter_materials" icon="far fa-search" :placeholder="$t('search')" :float-label="$t('search')" :debounce="600" />
                            <div class="col" />
                            <q-btn color="positive" icon="far fa-save" :label="$t('add')" @click="addMaterials()" v-if="materials_selected.length > 0" />
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th auto-width>
                                <q-checkbox v-model="props.selected" indeterminate-value="some" />
                            </q-th>

                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width>
                                <q-checkbox color="primary" v-model="props.selected" />
                            </q-td>

                            <q-td key="material_id" :props="props">
                                {{ props.row.material_id }}
                            </q-td>

                            <q-td key="material" :props="props">
                                {{ props.row.material }}
                            </q-td>

                            <q-td key="qty_material" :props="props">
                                <q-input type="number" v-model="props.row.qty_material" />
                            </q-td>

                            <q-td key="unit_material_cost" :props="props">
                                $ {{ props.row.unit_material_cost.toFixed(2) }}
                            </q-td>

                            <q-td key="total_material_cost" :props="props">
                                $ {{ (props.row.qty_material * props.row.unit_material_cost).toFixed(2) }}
                            </q-td>
                        </q-tr>
                    </q-table>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, minValue } from 'vuelidate/lib/validators'

export default {
    name: 'AdminPresentialMaterials',

    props: ['status', 'is_training_manager', 'manage_models'],

    data() {
        return {
            materials: [],
            columns_materials: [
                {
                    name: 'material_id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'material_id',
                    sortable: false,
                },
                {
                    name: 'material',
                    required: true,
                    label: 'material',
                    align: 'left',
                    field: 'material',
                    sortable: false,
                },
                {
                    name: 'qty_material',
                    required: true,
                    label: 'quantity',
                    align: 'left',
                    field: 'qty_material',
                    sortable: false,
                },
                {
                    name: 'unit_material_cost',
                    required: true,
                    label: 'unitary_value',
                    align: 'left',
                    field: 'unit_material_cost',
                    sortable: false,
                },
                {
                    name: 'total_material_cost',
                    required: true,
                    label: 'total_cost',
                    align: 'left',
                    field: 'total_material_cost',
                    sortable: false,
                },
                // {
                //     name: 'actions',
                //     required: true,
                //     label: '',
                //     align: 'left',
                //     field: 'actions',
                //     sortable: false,
                // },
            ],
            filter_materials: '',
            materials_list: [],
            materials_selected: [],
            show_materials: false,
            loading: false,
            materials_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 5,
                descending: false,
                sortBy: null
            },
            server_pagination: {
                page: 1,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
        }
    },

    computed: {
		...mapGetters({
            access_token: 'common/access_token'
		}),

		getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        disableMaterials() {
            if (this.status === 9) {
                if(this.manage_models) return false
                else return true
            }
            else if (this.status ===  1 || this.status === 6 || this.status === 5 || this.status === 9 || this.is_training_manager || this.presential_event_id === 0) return false
            else return true
        },
    },

    methods: {
        requestMaterials({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter_materials,
                "ordering": order_by
            }

            this.$axios.get(`/presential/presential_events/${this.presential_event_id}/materials/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.materials = response.data.results.map(e => {
                    return { ...e, actions: e.user_id, selected: false }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        requestNewMaterials({ pagination }) {
            this.loading = true
            this.materials_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.materials_pagination.rowsPerPage,
                "page": this.materials_pagination.page,
                "search": this.filter_materials,
                "ordering": order_by
            }

            this.$axios.get(`/presential/presential_events/${this.presential_event_id}/materials/get_materials/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.materials_pagination.rowsNumber = response.data.count

                this.materials_list = response.data.results.map(e => {
                    return { ...e, selected: false, qty_material: 0, total_material_cost: 0 }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        saveMaterials() {
            this.$q.loading.show()

            let data = {
                materials: this.materials
            }

            this.$axios.post(`/presential/presential_events/${this.presential_event_id}/materials/`, data, this.getHeader)
            .then(response => {
                this.$q.notify({
                    message: this.$t('input_list_save_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })

                this.materials = response.data.map(e => {
                    return { ...e, actions: e.user_id, selected: false }
                })
            })
            .catch(e => {
                console.log(e)

                this.$q.notify({
                    message: this.$t('input_list_save_error'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
            })
            .finally(() => {
                this.$q.loading.hide()
                this.show_materials = false
            })
        },

        showAddMaterials() {
            this.materials_selected = []
            this.requestNewMaterials({
                pagination: {
                    page: 1,
                    rowsNumber: 10,
                    rowsPerPage: 5,
                    descending: false,
                    sortBy: null
                }
            })
            this.filter_materials = ''
            this.show_materials = true
        },

        addMaterials() {
            this.$v.materials_selected.$touch()

            if (!this.$v.materials_selected.$error) {
                this.materials_selected.map(e => {
                    this.materials.push(e)
                })

                this.clearMaterialsSelection()
                this.saveMaterials()
            }
            else {
                this.$q.notify({
                    message: this.$t('you_need_to_inform_the_quantity_of_all_selected_materials'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })
            }
        },

        removeMaterial(props) {
            this.materials.splice(props.row.__index, 1)
            this.saveMaterials()
        },

        removeMaterials() {
            this.materials_selected.map(e => {
                this.materials = this.materials.filter(f => f.material_id !== e.material_id)
            })

            this.clearMaterialsSelection()
            this.saveMaterials()
        },

        clearMaterialsSelection() {
            this.materials_selected = []
            this.requestMaterials({
                pagination: {
                    page: 1,
                    rowsNumber: 10,
                    rowsPerPage: 5,
                    descending: false,
                    sortBy: null
                }
            })
        },

        checkMaterials() {
            this.$v.materials.$touch()

            if (!this.$v.materials.$error) {
                this.saveMaterials()
            }
        },
    },

    created() {
        this.presential_event_id = this.$route.params.id

        this.requestMaterials({
            pagination: this.server_pagination
        })
    },

    validations() {
        return {
            materials: {
                $each: {
                    qty_material: {
                        required,
                        minValue: minValue(1)
                    }
                }
            },
            materials_selected: {
                $each: {
                    qty_material: {
                        required,
                        minValue: minValue(1)
                    }
                }
            }
        }
    }
}
</script>

<style>

</style>
